// util
export const state = () => ({
  mapDarkmode: true
})

export const mutations = {
  setDarkmode(state, payload) {
    localStorage.setItem('darkMode', payload)
    state.mapDarkmode = payload
  }
}
